import { detectCardBrand as detectAllowedBrand } from "../constants/card-brands";

/**
 * Card brand detection + display helpers for CVS tokenize payloads.
 * Broader than the partner allowed-brand picker (includes amex/discover).
 */

export type CardBrand =
  | "visa"
  | "mastercard"
  | "amex"
  | "discover"
  | "unknown";

const BRAND_RULES: Array<{ brand: CardBrand; pattern: RegExp }> = [
  { brand: "visa", pattern: /^4/ },
  { brand: "mastercard", pattern: /^(5[1-5]|2[2-7])/ },
  { brand: "amex", pattern: /^3[47]/ },
  { brand: "discover", pattern: /^(6011|65|64[4-9])/ },
];

export const detectCardBrand = (pan: string): CardBrand => {
  const digits = pan.replace(/\D/g, "");
  if (!digits) return "unknown";
  return BRAND_RULES.find((r) => r.pattern.test(digits))?.brand ?? "unknown";
};

export const last4 = (pan: string): string =>
  pan.replace(/\D/g, "").slice(-4);

/** Map partner picker brand keys to CVS CardCompany when available. */
export const brandFromPan = (pan: string): string => {
  const allowed = detectAllowedBrand(pan);
  if (allowed) return allowed.toUpperCase();
  const detected = detectCardBrand(pan);
  if (detected === "unknown") return "OTHER";
  return detected.toUpperCase();
};

/** Display/list brand — CVS list returns lowercase; keep UI consistently UPPER. */
export const formatCardBrandDisplay = (brand: string | undefined | null): string =>
  (brand || "").trim().toUpperCase();
